import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await register(form);
    setBusy(false);
    if (res.ok) {
      toast.success("Account created!");
      navigate("/ricepoints");
    } else setError(res.error);
  };

  return (
    <div className="mx-auto max-w-md px-4 py-14">
      <div className="flex justify-center mb-6">
        <BrandMark iconSize={46} textSize="text-2xl" teluguSize="text-base" />
      </div>
      <div className="bg-card border border-border rounded-xl p-6 sm:p-8">
        <h1 className="font-heading font-bold text-2xl">Create your account</h1>
        <p className="text-sm text-muted-foreground mt-1">Start earning RicePoints today.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>Full name</Label><Input required value={form.name} onChange={set("name")} data-testid="register-name" className="mt-1.5" /></div>
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={set("email")} data-testid="register-email" className="mt-1.5" /></div>
          <div><Label>Phone (WhatsApp)</Label><Input value={form.phone} onChange={set("phone")} data-testid="register-phone" className="mt-1.5" placeholder="+91…" /></div>
          <div><Label>Password</Label><Input type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="register-password" className="mt-1.5" placeholder="min 6 characters" /></div>
          {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit">{busy ? "Creating…" : "Create account"}</Button>
        </form>
        <p className="mt-6 text-sm text-center text-muted-foreground">
          Already have an account? <Link to="/login" className="text-primary font-semibold" data-testid="to-login">Login</Link>
        </p>
      </div>
    </div>
  );
}
